import { Flex } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { AuthCallbackPath } from "../../../api-types/connector-callbacks";
import { QuickbooksConnect } from "../../../components";
import { ConnectorNavigationGroup } from "../../../components/connect/common/navigation-group";
import { usePlatformConnectorProperties } from "../../../hooks/connector";
import { CodatSupportingContent, ConnectorPageTemplate } from "../components";

import { MESSAGES } from "./message-definitions";

const CONNECTOR_SLUG = "quickbooks";

export const QuickbooksPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(
    customerDomain,
    CONNECTOR_SLUG,
    AuthCallbackPath.FUNDING_APPLICATION_ADD_CONNECTION
  );
  const hasConnections = !!connectorProperties.connections.length;

  return (
    <ConnectorPageTemplate
      title={intl.formatMessage(MESSAGES.connectTitle, { connectorName: "Quickbooks" })}
      primaryContent={
        <Flex direction="column" gap="8">
          <QuickbooksConnect />
          <ConnectorNavigationGroup hasConnections={hasConnections} forSlug={CONNECTOR_SLUG} />
        </Flex>
      }
      secondaryContent={<CodatSupportingContent />}
    />
  );
};
